import { Component, inject } from '@angular/core';
import { BannerComponent } from 'app/shared/components/banner/banner.component';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { StepperComponent } from 'app/shared/components/stepper/stepper.component';
import { LandingpageConfigurationStateService } from 'app/shared/services/state/landingpage-configuration-state.service';
import { Themes } from 'themes';

@Component({
  selector: 'ez-completion',
  imports: [MainLayoutComponent, BannerComponent, StepperComponent],
  templateUrl: './completion.component.html',
  styleUrl: './completion.component.scss',
})
export class CompletionComponent {
  private readonly landingpageConfigurationStateService = inject(LandingpageConfigurationStateService);

  readonly organisation = this.landingpageConfigurationStateService.organisation;
  readonly cardProductTexts = this.landingpageConfigurationStateService.cardProductTexts;

  protected readonly Themes = Themes;
}
